import logoUrl from '../../assets/images/Senerfi-formato.png';
import { getQualityPrintMeta } from './qualityPrintConfig';

export async function printResponsibleSummary({
  responsibleName,
  responsibleDoc,
  warehouseLabel,
  generatedAt,
  assignedBy = '',
  subjectLabel = 'Responsable',
  subjectIdLabel = 'Documento',
  headerTitle = 'ACTA ENTREGA DOTACION',
  headerSubtitle = 'Resumen de Asignacion de Dotacion',
  code = 'FT-SIG-082',
  qualityKey = 'responsable_dotacion',
  headerVariant = 'default',
  versionValue = '',
  effectiveDate = '',
  footerVariant = 'default',
  details = [],
  totals = []
}) {
  try {
    const qualityMeta = await getQualityPrintMeta(qualityKey);
    const resolvedCode = code || qualityMeta?.code || '';
    const resolvedVersionValue = versionValue || qualityMeta?.version || '';
    const resolvedEffectiveDate = effectiveDate || qualityMeta?.effective_date_display || '';
    const resolvedLogo = new URL(logoUrl, window.location.origin).toString();
    let logoSrc = resolvedLogo;
    try {
      const resp = await fetch(resolvedLogo, { cache: 'no-store' });
      if (resp.ok) {
        const blob = await resp.blob();
        logoSrc = await new Promise((resolve) => {
          const reader = new FileReader();
          reader.onloadend = () => resolve(reader.result);
          reader.readAsDataURL(blob);
        });
      }
    } catch (e) {}

    const frame = document.createElement('iframe');
    frame.style.position = 'fixed';
    frame.style.right = '0';
    frame.style.bottom = '0';
    frame.style.width = '0';
    frame.style.height = '0';
    frame.style.border = '0';
    frame.name = 'PRINT_RESP_SUMMARY';
    document.body.appendChild(frame);
    const w = frame.contentWindow;

    const detailRowsHtml = (details || []).map((r, idx) => `
      <tr>
        <td class="center">${idx + 1}</td>
        <td class="wrap">${r.Material || ''}</td>
        <td class="wrap">${r.Serie || ''}</td>
        <td class="wrap">${r.Marca || ''}</td>
        <td class="center">${r.Cantidad || ''}</td>
        <td class="wrap">${r.Bodega || ''}</td>
        <td class="center">${r['Fecha asignación'] || ''}</td>
        <td class="wrap">${r.Observaciones || ''}</td>
      </tr>
    `).join('');

    const totalsRowsHtml = (totals || []).map((t, idx) => `
      <tr>
        <td class="center">${idx + 1}</td>
        <td>${t.Material || ''}</td>
        <td class="center">${t['Total asignado'] || ''}</td>
      </tr>
    `).join('');

    w.document.write(`<!doctype html><html lang="es"><head><meta charset="utf-8" />
      <title>Resumen de Asignaciones por Responsable</title>
      <style>
        @page { size: 210mm 297mm; margin: 8mm; }
        @media print { body { -webkit-print-color-adjust: exact; print-color-adjust: exact; } }
        body{font-family: Arial, sans-serif; color:#000;}
        .sheet{width: 100%; max-width: 18.7cm; margin: 0 auto; padding: 6px; padding-bottom: 22mm; display:flex; flex-direction:column;}
        table{width:100%; border-collapse:collapse; table-layout: fixed;}
        td, th{border:1px solid #000; padding:4px 6px; font-size:9.5px; vertical-align:top; line-height:1.1; word-break:break-word; overflow-wrap:anywhere; white-space:normal}
        .no-border td, .no-border th{border:none}
        .header-title{font-weight:700; font-size:11.5px}
        .section-title{font-weight:600; background:#f7f7f7; border:1px solid #000; padding:4px 6px; font-size:10.5px}
        .small{font-size:9.5px}
        .center{text-align:center}
        .right{text-align:right}
        .logo{height:40px; max-width:100%; object-fit:contain; display:block; margin:0 auto}
        .logo-box{display:flex; align-items:center; justify-content:center; height:100%}
        .meta{font-size:9.5px}
        .wrap{word-break:break-word; overflow-wrap:anywhere; white-space:normal}
        .footer{position:fixed; bottom:0; left:0; right:0; padding: 0 8mm 2mm; background:#fff}
        .footer table{width:100%; table-layout:fixed}
      </style>
    </head><body>
      <div class="sheet">
        <table>
          <tr>
            <td rowspan="3" style="width:30%; text-align:center; vertical-align:middle">
              <div class="logo-box">
                <img src="${logoSrc}" alt="Senerfi" class="logo" />
              </div>
            </td>
            <td style="width:50%" class="center header-title">SOLUCIONES ENERGETICAS FORESTALES INTEGRALES</td>
            <td style="width:20%" class="center">
              <div class="header-title">CODIGO</div>
              <div>${resolvedCode || ''}</div>
            </td>
          </tr>
          <tr>
            <td class="center" style="font-weight:700">${headerTitle || ''}</td>
            <td class="center">
              ${
                headerVariant === 'vehicle'
                  ? `
                    <div class="header-title">VERSION</div>
                    <div style="font-weight:700">${resolvedVersionValue || ''}</div>
                  `
                  : `
                    <div class="header-title">FECHA</div>
                    <div>${generatedAt || new Date().toLocaleString('es-CO')}</div>
                    ${resolvedVersionValue || resolvedEffectiveDate ? `<div class="small">Version ${resolvedVersionValue || '-'} | Vigencia ${resolvedEffectiveDate || '-'}</div>` : ''}
                  `
              }
            </td>
          </tr>
          <tr>
            <td class="center">${headerSubtitle || ''}</td>
            <td class="center">
              ${
                headerVariant === 'vehicle'
                  ? `
                    <div class="header-title">FECHA</div>
                    <div style="font-weight:700">${resolvedEffectiveDate || ''}</div>
                    <div class="small">${generatedAt || new Date().toLocaleString('es-CO')}</div>
                  `
                  : `
                    <div class="header-title">BODEGA</div>
                    <div>${warehouseLabel || 'Todas'}</div>
                  `
              }
            </td>
          </tr>
        </table>

        <table style="margin-top:6px">
          <tr>
            <td class="meta"${(responsibleDoc || '').trim() ? '' : ' colspan="2"'}><strong>${subjectLabel}:</strong> ${responsibleName || ''}</td>
            ${(responsibleDoc || '').trim() ? `<td class="meta"><strong>${subjectIdLabel}:</strong> ${responsibleDoc || ''}</td>` : ''}
          </tr>
        </table>

        <table style="margin-top:6px">
          <tr><td class="section-title" colspan="8">Detalle de asignaciones</td></tr>
          <tr>
            <th style="width:5%" class="center">#</th>
            <th style="width:21%" class="center">Material</th>
            <th style="width:8%" class="center">Serie</th>
            <th style="width:8%" class="center">Marca</th>
            <th style="width:6%" class="center">Cantidad</th>
            <th style="width:8%" class="center">Bodega</th>
            <th style="width:12%" class="center">Asignado</th>
            <th style="width:32%" class="center">Observaciones</th>
          </tr>
          ${detailRowsHtml || '<tr><td colspan="8" class="center small" style="color:#777">Sin asignaciones activas.</td></tr>'}
        </table>

        <table style="margin-top:10px">
          <tr><td class="section-title" colspan="3">Totales por material</td></tr>
          <tr>
            <th style="width:8%" class="center">#</th>
            <th style="width:72%" class="center">Material</th>
            <th style="width:20%" class="center">Total Asignado</th>
          </tr>
          ${totalsRowsHtml || '<tr><td colspan="3" class="center small" style="color:#777">Sin datos.</td></tr>'}
        </table>

        <table class="no-border" style="margin-top:18px; width:100%">
          <tr>
            ${footerVariant === 'vehicle'
              ? `
                <td class="center small" style="width:33%; padding-top:18px">
                  ________________________________<br/>
                  FIRMA TRANSPORTES
                </td>
                <td class="center small" style="width:33%; padding-top:18px">
                  ________________________________<br/>
                  FIRMA QUIEN RECIBE VEHICULO
                </td>
                <td class="center small" style="width:33%; padding-top:18px">
                  ________________________________<br/>
                  FIRMA REINTEGRO
                </td>
              `
              : `
                <td class="center small" style="width:33%; padding-top:18px">
                  ________________________________<br/>
                  FIRMA COORD.HSEQ
                </td>
                <td class="center small" style="width:33%; padding-top:18px">
                  ________________________________<br/>
                  ALMACEN<br/>
                  ${assignedBy || ''}
                </td>
                <td class="center small" style="width:33%; padding-top:18px">
                  ________________________________<br/>
                  Firma ${subjectLabel}<br/>
                  ${responsibleName || ''}<br/>
                  ${(responsibleDoc || '').trim() ? `${subjectIdLabel}: ${responsibleDoc || ''}` : ''}
                </td>
              `
            }
          </tr>
        </table>
      </div>
      <div class="footer">
        <table class="no-border">
          <tr>
            <td class="small">Generado: ${generatedAt || new Date().toLocaleString('es-CO')}</td>
            <td class="right small">SENERFI</td>
          </tr>
        </table>
      </div>
      <script>
        window.addEventListener('load', function() {
          const img = document.querySelector('.logo');
          const fallbackSrc = window.location.origin + '/Senerfi-formato.png';
          const printNow = () => { window.focus(); window.print(); setTimeout(() => window.close(), 300); };

          if (!img) { printNow(); return; }
          if (img.complete && img.naturalWidth > 0) { printNow(); return; }
          img.addEventListener('load', printNow, { once: true });
          img.addEventListener('error', function onErr() {
            if (img.src !== fallbackSrc) {
              img.src = fallbackSrc;
              img.addEventListener('load', printNow, { once: true });
              img.addEventListener('error', printNow, { once: true });
            } else { printNow(); }
          }, { once: true });
          setTimeout(() => { if (img.complete && img.naturalWidth > 0) { printNow(); } }, 1200);
        });
      </script>
    </body></html>`);
    w.document.close();
    w.focus();
    frame.onload = () => {
      setTimeout(() => { try { document.body.removeChild(frame); } catch (e) {} }, 1500);
    };
  } catch (e) {
    console.error('Error printing responsible summary', e);
    alert('No se pudo generar el resumen para impresión.');
  }
}
